import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

import type { RBACGroup } from '../../../types';
import { intuneGroupUrl } from '../../graph/intune';

type Props = {
  acl: RBACGroup | undefined;
  userCount?: number;
  userCountIsFetching?: boolean;
  inWriteback?: boolean;
  inWritebackIsFetching?: boolean;
  // True when the ACL is itself mastered in on-prem AD (onPremisesSyncEnabled / Onprem_*).
  // For those the cloud→AD writeback membership check doesn't apply — they already live
  // in on-prem AD. See isOnPremGroup.
  isOnPrem?: boolean;
};

export default function ACLInfo({
  acl,
  userCount,
  userCountIsFetching,
  inWriteback,
  inWritebackIsFetching,
  isOnPrem,
}: Props) {
  if (!acl) {
    return <div></div>;
  }

  const description = 'description' in acl ? acl.description : undefined;

  return (
    <div className="min-w-0">
      <table className="text-sm table-fixed w-full">
        <tbody>
          <tr>
            <td className="text-left font-bold w-20 shrink-0 align-top">Name:</td>
            <td className="pl-2 truncate max-w-0" title={acl.displayName}>
              {acl.displayName}
            </td>
          </tr>
          <tr>
            <td className="text-left font-bold align-top">Members:</td>
            <td className="pl-2">
              {userCountIsFetching ? (
                <span className="loading loading-spinner loading-xs align-middle" />
              ) : userCount === undefined ? (
                '—'
              ) : (
                userCount
              )}
            </td>
          </tr>
          <tr>
            <td className="text-left font-bold align-top">Writeback:</td>
            <td className="pl-2">
              {isOnPrem ? (
                <span className="text-info">N/A — on-prem AD group</span>
              ) : inWritebackIsFetching ? (
                <span className="loading loading-spinner loading-xs align-middle" />
              ) : inWriteback === undefined ? (
                '—'
              ) : inWriteback ? (
                <span className="text-success">Synced</span>
              ) : (
                <span className="text-warning">Not synced — won&apos;t reach on-prem AD</span>
              )}
            </td>
          </tr>
          {description && (
            <tr>
              <td className="text-left font-bold align-top">Description:</td>
              <td className="pl-2 whitespace-normal">{description}</td>
            </tr>
          )}
          <tr>
            <td className="text-left font-bold align-top">Portal:</td>
            <td className="pl-2">
              <a
                className="link link-primary inline-flex items-center gap-1"
                href={intuneGroupUrl(acl.id)}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open in Intune
                <ArrowTopRightOnSquareIcon className="h-4 w-4 shrink-0" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
